import type { DividerStyleConfig } from './types';

const baseStyle = {
  borderColor: 'separator.divider',
};

const variants = {
  solid: {
    borderStyle: 'solid',
  },
  dashed: {
    borderStyle: 'dashed',
  },
};

const defaultProps = {
  variant: 'solid',
} as const;

export const DIVIDER_STYLE_CONFIG: DividerStyleConfig = {
  baseStyle,
  variants,
  defaultProps,
};
